import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface ScrollToBottomFabProps {
  visible: boolean;
  onClick: () => void;
}

const ScrollToBottomFab: React.FC<ScrollToBottomFabProps> = ({ visible, onClick }) => {
  const { t } = useTranslation('pages');

  if (!visible) return null;

  return (
    <Tooltip title={t('chatPreview.messagePanel.scrollToBottom')}>
      <Fab
        size="small"
        onClick={onClick}
        sx={{
          position: 'absolute',
          bottom: 16,
          right: 16,
          bgcolor: 'rgba(0,0,0,0.5)',
          color: '#fff',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
        }}
      >
        <KeyboardArrowDown />
      </Fab>
    </Tooltip>
  );
};

export default ScrollToBottomFab;
